

import { mapGetters } from 'vuex';

// Assets
import days from '../assets/data/days';
import minDays from '../assets/data/minDays';

export default {
  name: 'SScheduleWeek',
  props: {
    preview: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      days,
      smallPreview: false,
    };
  },
  computed: {
    ...mapGetters({
      getWindowWidth: 'screen/getWindowWidth',
    }),
  },
  watch: {
    // TODO Ajusté
    getWindowWidth: {
      immediate: true,
      handler(value) {
        this.days = value <= 400 ? minDays : days;
        this.initPreview();
      },
    },
  },
  methods: {
    initPreview() {
      this.$nextTick(() => {
        this.smallPreview = this.$refs.container?.clientWidth < 700;
      });
    },
  },
};

